import { oldPortfolioComponent } from './oldPortfolio.component';
import { stateResolver } from '../../app.state';

export const oldPortfolioStateName = 'app.oldPortfolio';

export const oldPortfolioState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    url: '/oldPortfolio',
    name: oldPortfolioStateName,
    component: oldPortfolioComponent.name,
    resolve: { stateResolver: stateResolver(oldPortfolioStateName) },
  });
};



// WEBPACK FOOTER //
// ./src/app/components/oldPortfolio/oldPortfolio.state.js